import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0","key":"svg-0"}]]

const IconOval = createReactComponent('outline', 'oval', 'Oval', __iconNode);

export default IconOval;